var _rect, _mask, _path, _tspan, _mask2, _path2, _tspan2, _tspan3, _tspan4, _rect2, _tspan5, _rect3, _rect4, _tspan6, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingmodal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 229,
    viewBox: "0 0 411 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_45576)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_45576)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 189,
    rx: 10,
    className: "component-background"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1002_45576)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1002_45576",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H384.5C387.814 10 390.5 12.6863 390.5 16V58H20.5V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H390.5H20.5ZM390.5 59H20.5V57H390.5V59ZM20.5 58V10V58ZM390.5 10V58V10Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1002_45576)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.71
  }, "VILL DU L\xC4MNA ETT OMD\xD6MME?")))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_1002_45576",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 58,
    width: 370,
    height: 78,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 58,
    width: 370,
    height: 78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 58H390.5V135H20.5V58Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 134H20.5V136H390.5V134Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-6-outside-2_1002_45576)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 83.9395
  }, "Om du gillar att anv\xE4nda Allsvenskan Live s\xE5 hade vi varit ")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 100.939
  }, "tacksamma om du ger oss ett omd\xF6mme. Det tar inte mer ")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 117.939
  }, "\xE4n n\xE5gra sekunder. Tack f\xF6r din support!"))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1002_45576)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 145.5,
    width: 169,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.6406,
    y: 168.14
  }, "NEJ TACK")))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1002_45576)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 145,
    width: 170,
    height: 40,
    rx: 6,
    className: "button-background",
    shapeRendering: "crispEdges"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 145.5,
    width: 169,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "button-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 244.389,
    y: 168.14
  }, "L\xC4MNA OMD\xD6MME"))))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.5,
    width: 369,
    height: 188,
    rx: 9.5,
    className: "component-border",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_45576",
    x: 0.5,
    y: 0,
    width: 410,
    height: 229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1002_45576",
    x: 10.5,
    y: 5,
    width: 390,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1002_45576",
    x: 10.5,
    y: 135,
    width: 210,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1002_45576",
    x: 190.5,
    y: 135,
    width: 210,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45576",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_45576"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 189,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingmodal);
export default __webpack_public_path__ + "static/media/ratingmodal.a3032e71759bd5eca9233587fbbe3481.svg";
export { ForwardRef as ReactComponent };